import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_REJECT_HALAL_STOCK_ORDER } from "../../../config/api";
import { getStockOrders } from "./getStockOrders";

export const rejectOrder = createAsyncThunk(
  "stocks/rejectOrder",
  async ({ id, data, callback }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_REJECT_HALAL_STOCK_ORDER(id),
        data: data,
      });
      toast.success("Order rejected successfully");
      dispatch(getStockOrders({ side: "buy" }));
      dispatch(getStockOrders({ side: "sell" }));
      callback && callback();
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
